/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/en-us';
import iconSet from 'quasar/icon-set/material-icons';
import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import QTime from 'quasar/src/components/time/QTime.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QDate from 'quasar/src/components/date/QDate.js';import QVideo from 'quasar/src/components/video/QVideo.js';import QUploader from 'quasar/src/components/uploader/QUploader.js';import QColor from 'quasar/src/components/color/QColor.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import AppFullscreen from 'quasar/src/plugins/AppFullscreen.js';import Dialog from 'quasar/src/plugins/Dialog.js';import BottomSheet from 'quasar/src/plugins/BottomSheet.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';;
Vue.use(Quasar, {
  config: {},
  lang: lang,
  iconSet: iconSet,
  components: {
    QTime: QTime,
    QTabPanels: QTabPanels,
    QTabPanel: QTabPanel,
    QIcon: QIcon,
    QDate: QDate,
    QVideo: QVideo,
    QUploader: QUploader,
    QColor: QColor,
    QCard: QCard,
    QCardSection: QCardSection,
    QCardActions: QCardActions
  },
  plugins: {
    LocalStorage: LocalStorage,
    AppFullscreen: AppFullscreen,
    Dialog: Dialog,
    BottomSheet: BottomSheet,
    Notify: Notify,
    Loading: Loading
  }
});